import { Card, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { Box } from '@mui/material';
import React from 'react';

export interface IMyCardProps {
    titleCard?: string;
    content?: any;
    addComponent?: any;
}

const MyCard = (props: IMyCardProps) => {

    //props
    const { titleCard, addComponent, content } = props




    return (
        <div>
            <Card>
                <CardHeader
                    style={{ background: "#E7EBF0" }}
                    title={
                        <Box style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Typography
                                style={{ fontSize: 18 }}
                                component="div"
                            >
                                <b>
                                    {titleCard}
                                </b>
                            </Typography>

                            <Typography variant='body1' >
                                {addComponent}
                            </Typography>
                        </Box>
                    }
                />
                <Divider />
                <CardContent>
                    {content}
                </CardContent>
            </Card>
        </div>
    );
}

export default MyCard;
